












































import { Component, Vue } from 'vue-property-decorator';
import Avatar from '@/components/Avatar.vue';
import Notifications from '@/components/notification/Notifications.vue';

import { OperatorFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    Avatar,
    Notifications
  }
})
export default class SideBar extends Vue {
  private name = 'SideBar';

  get user(): OperatorFields {
    return this.$store.getters['User/currentUser'] || {};
  }

  get avatar(): null | string {
    return this.user.avatar && this.user.avatar.url;
  }
}
